import React, { useEffect } from "react";
import Navbar from "../Navbar";
import {
  Box,
  Button,
  TextField,
  Grid,
  Divider,
  Typography,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

function EditSubCategory(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [productInput, setproduct] = useState({
    subname: "",
    category: "",
    error_list: [],
  });
  const [error, setError] = useState({
    subname: "",
    category: "",
    error_list: [],
  });

  const { id } = useParams();
  useEffect(() => {
    const product_id = id;
    axios.get(`/api/edit_subcategory/${product_id}`).then((res) => {
      if (res.data.status === 200) {
        setproduct(res.data.subcategory);
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/subcategory");
      }
      setLoading(false);
    });
  }, [id, navigate]);

  const handleInput = (e) => {
    e.persist();
    setproduct({ ...productInput, [e.target.name]: e.target.value });
  };
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    );
  }
  const [sublist, setsublist] = useState([]);
  useEffect(() => {
    axios.get(`api/show-product`).then((res) => {
      if (res.status === 200) {
        setsublist(res.data.product);
      }
    });
  }, []);
  const values = sublist.map((item) => {
    return (
      <option color="blue" value={sublist.subname}>
        {item.name}
      </option>
    );
  });

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const updateProduct = (e) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const product_id = id;
    const data = {
      subname: productInput.subname,
      category: productInput.category,
      user_id:userId,
    };
    
    axios.put(`/api/update_subcategory/${product_id}`, data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        setError([]);
        navigate("/certificates/subcategory");
      } else if (res.data.status === 422) {
        // swal("All fields are mandatory","","error");
        setError({ ...productInput, error_list: res.data.errors });
      } else if (res.data.status === 404) {
        swal("Error", res.data.message, "error");
        navigate("/certificates/subcategory");
      }
    });
  };

  return (
    <div>
      <Navbar />

      <div className="card px-8 m-5">
        <div className="card-header">
          <Grid container spacing={70}>
            <Grid item xs={8}>
              <h4>Edit Sub Category</h4>
            </Grid>
            <Grid item xs={4}>
              <ThemeProvider theme={theme}>
                <Button
                  component={Link}
                  to="/certificates/subcategory"
                  variant="contained"
                  color="apple"
                >
                  Back
                </Button>
              </ThemeProvider>
            </Grid>
          </Grid>
        </div>
        <form onSubmit={updateProduct} id="SUBCATEGORY_FORM">
          <Box padding={1} borderRadius={1} paddingLeft={35} paddingRight={35}>
            <Box marginTop={2} padding={1} borderRadius={1}>
              <select
                name="category"
                class="form-select"
                aria-label="Default select example"
                onChange={handleInput}
                value={productInput.category}
              >
                <option selected>Category</option>
                {values}
              </select>
              <span style={{ color: "red" }}>{error.error_list.category}</span>
            </Box>
            {/* <Grid container spacing={5}> */}
            <Grid item xs={15}>
              {/*<Box marginTop={2} padding={1} borderRadius={1}>*/}
                <TextField
                  InputLabelProps={{ shrink: true }}
                  fullWidth
                  name="subname"
                  sx={{ input: { background: "white" } }}
                  onChange={handleInput}
                  value={productInput.subname}
                  id="filled-outlined"
                  margin="normal"
                  label="SubCategory Name"
                  variant="outlined"
                />
                <span style={{ color: "red" }}>{error.error_list.subname}</span>
              {/*</Box>*/}
            </Grid>
            {/* </Grid> */}

            <Box
              marginTop={1}
              display="flex"
              padding={3}
              borderRadius={5}
              alignItems="center"
              justifyContent={"center"}
            >
              <ThemeProvider theme={theme}>
                <Button
                  style={{
                    maxWidth: "200px",
                    maxHeight: "100px",
                    minWidth: "50px",
                    minHeight: "30px",
                  }}
                  color="apple"
                  type="submit"
                  variant="contained"
                >
                  Update
                </Button>
              </ThemeProvider>
            </Box>
          </Box>
        </form>
      </div>
    </div>
  );
}

export default EditSubCategory;
